import GoalUnreachedMessage from './GoalUnreachedMessage';
export default GoalUnreachedMessage;